// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const EmployeesPage = lazy(() => import('./pages/EmployeesPage'));
const OrgChartPage = lazy(() => import('./pages/OrgChartPage'));
const LeaveBasicPage = lazy(() => import('./pages/LeaveBasicPage'));
const HrDocumentsPage = lazy(() => import('./pages/HrDocumentsPage'));

export const CoreRoutes: RouteObject = {
  path: 'core',
  element: <ModuleGuard moduleId="people.core" />,
  handle: { crumb: 'HR Core' },
  children: [
    { index: true, element: <Navigate to="employees" replace /> },
    { path: 'employees', element: <EmployeesPage />, handle: { crumb: 'Employees' } },
    { path: 'org-chart', element: <OrgChartPage />, handle: { crumb: 'Org Chart' } },
    { path: 'leave-basic', element: <LeaveBasicPage />, handle: { crumb: 'Leave Basic' } },
    { path: 'hr-documents', element: <HrDocumentsPage />, handle: { crumb: 'Hr Documents' } },
  ],
};
